import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableSequence } from '@teetsh/app/src/types/sequences';

export const SEQUENCES_TRASH_KEY = 'sequences_trash';

function fetchSequencesTrash() {
  const requestURL = '/sequences/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableSequence[] }) => data || []);
}

export function useSequencesTrash() {
  return useQuery({
    queryKey: [SEQUENCES_TRASH_KEY],
    queryFn: () => fetchSequencesTrash(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
